import './App.css';
import Panel from './component/Panel'

function App() {
  return (
    <div>
      <Panel/>
    </div>
  );
}

export default App;